import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { SITE } from "@/constants/testIds";
import { SectionHead } from "./Reveal";
import { AppointmentForm } from "./AppointmentForm";
import { RequestForm } from "./RequestForm";

const tab = "rounded-none px-0 pb-4 h-auto bg-transparent text-sm md:text-base font-semibold text-navy-500 border-b-2 border-transparent data-[state=active]:border-navy-900 data-[state=active]:text-navy-900 data-[state=active]:shadow-none data-[state=active]:bg-transparent transition-colors";

export const Booking = () => (
  <section id="prenota" className="section-pad bg-navy-50">
    <div className="container-x">
      <SectionHead
        index="05"
        eyebrow="Prenota"
        title="Parliamone. Scegli tu quando."
        intro="Scegli giorno e orario direttamente online, oppure lascia una breve descrizione del tuo caso: lo studio ti risponderà in fretta."
      />
      <div className="rounded-[2rem] bg-white border border-navy-100 p-6 sm:p-10 lg:p-14 shadow-[0_8px_30px_rgba(0,43,74,0.05)]">
        <Tabs defaultValue="appuntamento" data-testid={SITE.bookingTabs}>
          <TabsList className="bg-transparent p-0 h-auto gap-8 mb-10 border-b border-navy-100 w-full justify-start rounded-none">
            <TabsTrigger value="appuntamento" data-testid={SITE.tabAppointment} className={tab}>Prenota un appuntamento</TabsTrigger>
            <TabsTrigger value="richiesta" data-testid={SITE.tabRequest} className={tab}>Richiedi una consulenza</TabsTrigger>
          </TabsList>
          <TabsContent value="appuntamento"><AppointmentForm /></TabsContent>
          <TabsContent value="richiesta"><RequestForm /></TabsContent>
        </Tabs>
      </div>
    </div>
  </section>
);
